import { IKanbanState } from './kanban-states.store'
import { MutationTree } from 'vuex';
import _set from 'lodash/set';

import KanbanStoreTypes from './kanban-types.stores';


const mutations: MutationTree<IKanbanState> = <MutationTree<IKanbanState>>{
    [KanbanStoreTypes.Set.KANBAN_URL]: (state, payload: string) => {
        state.kanbanUrl = payload;
    },
    
}

export default mutations;